import React from 'react'
import { withStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Title from 'components/Title';
import AllSections from './components/AllSections';
import Tr from 'translations/Translations';
import elements from './constants/selection.values'
import RadioGroup from 'components/RadioGroup';
import EspdBooleanItems from 'constants/EspdBooleanItems';
import getObjectValue from "libs/getObjectValue";

const style = theme => ({
	root: {
		'&>*': {
			marginTop: theme.spacing(2)
		}
	}
})

function SelectionSection({
	classes,
	formikProps,
	idPrefix
}) {
	const variant = getObjectValue(`${idPrefix}.qualifications`, formikProps.values)

	return (
		<GridBlock
			column
			className={classes.root}
		>
			<Title align='center'>
				{Tr('qualifications')}
			</Title>
			<Typography variant='body1'>
				{Tr('jedz_se')}
			</Typography>

			<RadioGroup
				id={`${idPrefix}.qualifications`}
				items={EspdBooleanItems}
				formikProps={formikProps}
			/>

			<AllSections
				formikProps={formikProps}
				values={elements[variant==='yes']}
				idPrefix={idPrefix}
			/>
		</GridBlock>
	)
}

SelectionSection.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(SelectionSection);